/*

FILE: elements.js
DESCRIPTION: Element refs for use in various modules
AUTHOR(S): R.J. LaCount / Nick Katarow

*/

const elements = {};

/**
 * @description Assign element refs for use in various modules
 */
const setElementRefs = () => {
    const base = document;

    // Root-level elements
    elements.links = document.querySelectorAll('a');

    // Page-level elements
    elements.animateIn = base.querySelectorAll('[data-animation-type]');
    elements.stickyPanelContainer = base.querySelector('.sticky-panels');
    elements.stackedImages = base.querySelectorAll('.stacked-images');
    elements.gaussianBlur = base.querySelectorAll('.gaussian-blur');
    elements.appPreview = base.querySelectorAll('.app-preview');
};

export { elements, setElementRefs };
